export const SPELL_REFRESH_EVENT = 'campaign:spell-refresh';

export function bindSpellRefreshEvents(socket, campaignId) {
  // [event, web, concentration, rollRequests, fateWindows, dmNotes]: which prompts reload on it.
  const bindings = [
    ['connect', true, true, true, true, true],
    ['combat:update', true, true, false, false, true],
    ['character:health:update', true, true, false, false, true],
    ['campaign:enemies:update', true, true, false, false, true],
    ['campaign:map:update', true, false, false, false],
    ['campaign:roll-requests:update', false, false, true, false],
    ['campaign:fate-windows:update', false, false, false, true],
    ['campaign:dm-notes:update', false, false, false, false, true],
  ].map(([event, web, concentration, rollRequests, fateWindows, dmNotes = false]) => {
    const handler = () => window.dispatchEvent(new CustomEvent(SPELL_REFRESH_EVENT,
      { detail: { campaignId, web, concentration, rollRequests, fateWindows, dmNotes } }));
    socket.on(event, handler);
    return [event, handler];
  });
  return () => bindings.forEach(([event, handler]) => socket.off(event, handler));
}
